module.exports = __webpack_public_path__ + "img/picture3.197e19c7.jpg";